import { render, staticRenderFns } from "./ManagePassword.vue?vue&type=template&id=17b226a2"
import script from "./ManagePassword.vue?vue&type=script&lang=js"
export * from "./ManagePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports